document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("recent-products-container");
  const section = document.getElementById("section-recent-viewed");
  if (!container) return;

  let productsMap = {};
  try {
    const raw = localStorage.getItem("products");
    productsMap = raw ? JSON.parse(raw) : {};
  } catch (err) {
    console.error("Error parsing localStorage 'products':", err);
    container.innerHTML = "<p class='error-message'>Error leyendo productos recientes.</p>";
    return;
  }

  const products = Object.values(productsMap || {});
  if (products.length === 0) {
    section.style.display = "none";
    container.innerHTML = "<p class='no-products-message'>No has visto productos aún.</p>";
    return;
  }

  const MAX = 8;
  const recent = products.slice(-MAX).reverse();

  function extractImageUrl(p) {
    return (
      p.featured_image?.src ||
      p.featured_image?.url ||
      p.images?.[0]?.src ||
      p.images?.[0]?.url ||
      p.media?.[0]?.preview_image?.src ||
      p.media?.[0]?.image?.src ||
      p.media?.[0]?.src ||
      "https://via.placeholder.com/150"
    );
  }

  function addProduct(data) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json());
  }

  container.innerHTML = "";

  const sliderContainer = document.createElement("div");
  sliderContainer.className = "recent-products-slider";
  
  const sliderTrack = document.createElement("div");
  sliderTrack.className = "recent-products-track";

  recent.forEach(p => {
    const imageUrl = extractImageUrl(p);
    const priceDisplay = "$ " + (p.price/100) ;

    const card = document.createElement("div");
    card.className = "recent-product-card";

    const link = document.createElement("a");
    link.href = p.handle ? `/products/${p.handle}` : "#";
    link.className = "recent-product-link";

    const title = document.createElement("h3");
    title.textContent = p.title || "Sin título";
    title.className = "recent-product-title";

    const img = document.createElement("img");
    img.src = imageUrl;
    img.alt = p.title || "Producto";
    img.className = "recent-product-image";

    img.onerror = function () {
      this.onerror = null;
      this.src = "https://via.placeholder.com/150";
    };

    const price = document.createElement("div");
    price.classList.add('product-price');
    price.textContent = `${priceDisplay} MXN`;

    const button = document.createElement("button");
    button.type = "button";
    button.className = "new-product-atc";
    button.setAttribute(
      "aria-label",
      `Agregar al carrito`
    );

    button.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M3 4H5L7.2 14.2C7.4 15.1 8.2 15.8 9.2 15.8H18.1C19 15.8 19.8 15.2 20 14.3L21.4 7.3H6.1"
          stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="9.5" cy="19.2" r="1.4" fill="currentColor"/>
        <circle cx="17.5" cy="19.2" r="1.4" fill="currentColor"/>
      </svg>
      <span>Agregar al carrito</span>
    `;

    button.addEventListener("click", async (e) => {
      e.preventDefault();

      if (button.classList.contains("is-loading")) return;

      button.classList.add("is-loading");

      try {
        await addProduct({
          items: [{
            id: p.variants[0].id,
            quantity: 1
          }]
        });

        // opcional: feedback success
        button.classList.remove("is-loading");
        button.querySelector("span").textContent = "Agregado ✔";

      } catch (error) {
        console.error(error);
        button.classList.remove("is-loading");
      }
    });


    link.appendChild(title);
    link.appendChild(img);
    link.appendChild(price);
    card.appendChild(link);
    card.appendChild(button);
    sliderTrack.appendChild(card);
  });

  sliderContainer.appendChild(sliderTrack);
  container.appendChild(sliderContainer);


  const buttons = document.querySelectorAll('#add-product-release');

  buttons.forEach((button) => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();

      if (button.classList.contains("is-loading")) return;

      const variantId = button.dataset.variantId;

      if (!variantId) {
        console.error('No variantId');
        return;
      }

      button.classList.add("is-loading");

      try {
        await addProduct({
          items: [{
            id: variantId,
            quantity: 1
          }]
        });

        button.classList.remove("is-loading");
        button.querySelector("span").textContent = "Agregado ✔";

      } catch (err) {
        console.error('Error agregando al carrito', err);
        button.classList.remove("is-loading");
      }
    });
  });

});